// extracted by mini-css-extract-plugin
export default {"appealInfoButtons":"LkmAppealDetailInfoButtons_appealInfoButtons__HhW3r"};